jQuery(document).ready(function($) {
  $(".toolbar .toolbar__menu > li > a.hassubmenu").hover(function(e) {
    $(this).parent().addClass("submenu_open");
  }, function(e) {
    $(this).parent().removeClass("submenu_open");
  });
  
  $(".submenu").hover(function(e) {
    $(this).parent().addClass("submenu_open");
  }, function(e) {
    $(this).parent().removeClass("submenu_open");
  });
  
  if($(".product-description").length > 0) {
    if($(".product-description .rte").height() < 200) {
      $(".product-description").addClass("full");
    }
  }
  
  $(".desc_btn-readmore").click(function(e) {
    console.log($(this).parents(".product-description"));
    $(this).parents(".product-description").find(".desc_readmore").removeClass("hide");
    $(this).addClass("hide");
  });
  

  
//   $(".color-swatches-wrapper .variant-input").hover(function(e) {
//     $(this).find(".color_tooltip").removeClass("hide");
//   }, function(e) {
//     $(this).find(".color_tooltip").addClass("hide");
//   });
  
  $(".variant_sel-trigger").change(function(e) {
    var hdl = $(this).attr("data-handle");
    var val = $(this).find("option:selected").val();
    console.log(".variant-input-wrap[data-handle='" + hdl + "'] .variant-input[data-value='" + val + "']");
    $(".variant-input-wrap[data-handle='" + hdl + "'] .variant-input[data-value='" + val + "'] label").trigger("click");
  });
  
  $(".shopify-app-block").addClass("page-width");
  
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener nofollow';
  }
}


document.addEventListener("DOMContentLoaded", function () {
  // Fetch the cart data
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      cart.items.forEach(item => {
        // Check if the product title matches the specific product
        if (item.title === "Boston Bruins Sidelines NHL Team Logo Helmet Decals") {
          if (item.quantity > 1) {
            updateQuantityToOne(item.id);
          }
        }
      });
    });

  // Listen for cart updates
  document.body.addEventListener("change", function (event) {
    if (event.target.matches('[name="updates[]"]')) {
      // Update quantity if necessary
      const lineItemId = event.target.dataset.id;
      const newQuantity = parseInt(event.target.value, 10);

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const item = cart.items.find(i => i.id === lineItemId);
          if (item && item.title === "Boston Bruins Sidelines NHL Team Logo Helmet Decals" && newQuantity > 1) {
            updateQuantityToOne(item.id);
          }
        });
    }
  });

  function updateQuantityToOne(itemId) {
    // Send the cart update request
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: itemId,
        quantity: 1
      })
    }).then(response => response.json())
      .then(cart => {
        // Optionally reload the cart or update UI
        location.reload();
      });
  }
});

